import { atom } from "recoil";
import { ReactNodeArray } from "src/types/common";

export const hoverTotalsContentState = atom<ReactNodeArray[]>({
  key: "hoverTotalsContentState",
  default: [],
});
